var mentions_default = {
  "mentionPalette": "qupv0",
  "mention": "ZCk2H",
  "mentionViewer": "arVpQ",
  "mentionSuggestionsEntry": "rdPAP",
  "mentionSuggestionsEntryFocused": "s7d0P",
  "mentionSuggestionsEntryText": "xOT2L",
  "mentionSuggestionsEntryAvatar": "SWZmz",
  "mentionSuggestions": "MxalI",
  "cursorDefault": "ZHS3P",
  "cursorPointer": "W-dYq"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
